

class Affliation {

    constructor(affiliation) {
        const { subscription_count, display_name, phone, email, address, city, logo, grades, division, institution_code, id, contact_email, principal_last_name, principal_first_name, principal_phone, principal_email, school, method, name, group, contact_first_name, contact_last_name, contact_phone } = affiliation

        // מיועד לעדכון של מוסד
        if (id)
            this.id = id

        if (name)
            this.name = name
        if (subscription_count)
            this.subscription_count = subscription_count
        if (display_name)
            this.display_name = display_name
        if (email)
            this.email = email
        if (phone)
            this.phone = phone
        if (logo && logo.file)
            this.logo = logo.file
        if (city)
            this.city = city
        if (address)
            this.address = address
        if (principal_first_name)
            this.principal_first_name = principal_first_name
        if (principal_last_name)
            this.principal_last_name = principal_last_name
        if (principal_email)
            this.principal_email = principal_email
        if (principal_phone)
            this.principal_phone = principal_phone

        if (contact_email)
            this.contact_email = contact_email
        if (contact_phone)
            this.contact_phone = contact_phone
        if (contact_first_name)
            this.contact_first_name = contact_first_name
        if (contact_last_name)
            this.contact_last_name = contact_last_name
        if (institution_code)
            this.institution_code = institution_code

        if (school) {
            this.name = school?.name
            this.city = school?.area
            this.institution_code = school?.institution_code
        }

        if (group)
            this.group = group.id || group
        if (method)
            this.method = method.id || method

        let gradeArray = []

        if (grades) {
            Object.keys(grades).forEach((gradeKey) => {
                if (grades[gradeKey]?.active)
                    gradeArray.push({
                        grade: gradeKey,
                        classes: grades[gradeKey]?.classes || 0,
                        name: grades[gradeKey]?.name
                    })
            })
            this.grades = gradeArray
        }
    }
}

export default Affliation